import { controls,grouped } from "../controls";
const widgets = {
label: "Widgets",
pageLabel: "Widgets",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Labels",uid: "widget_label",parents:[{"name": "widget_type_code", "match": "in", "value": ["list"]}],fastpath:"widget_labels"},
{label: "Values",uid: "widget_value",parents:[{"name": "widget_type_code", "match": "in", "value": ["list"]}],fastpath:"widget_values"},
{label: "Chart",uid: "widget_chart",parents:[{"name": "widget_type_code", "match": "in", "value": ["nbar"]}],fastpath:"widget_charts"},
{label: "Widget Progressbar",uid: "widget_progressbar",fastpath:"widget_progressbars"},
{label: "Menu",uid: "widget_menus",parents:[{"name": "widget_type_code", "match": "in", "value": ["list"]}],fastpath:"widget_menus"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "widget_code",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Widget Type"}),
...controls.oc({ tab: "filter", c: "WidgetType", placeHolder: "Widget Type Code", name: "Widget-widget_type-widget_type_code",fastpath: "widget_types"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "Widget-widget_type-widget_type_display"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Code",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "widget_code",isRequired:true,maxlength:50}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Description",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "widget_display",isRequired:true,width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Widget Type",star:true}),
...controls.oc({ tab: "general", c: "WidgetType", placeHolder: "Widget Type Code", name: "widget_type_code",isRequired:true,fastpath: "widget_types",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "widget_type_display"}),
...controls.displayText({ tab: "general", label: "Title Text",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "title_text",isRequired:true,width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Title Icon",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "title_icon",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Footer Text",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "footer_text",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Title Tag Field",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "title_tag_field",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Form",star:false}),
...controls.oc({ tab: "general", c: "Form", placeHolder: "Form Code", name: "form_code",fastpath: "forms",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "form_display"}),
...controls.displayText({ tab: "general", label: "Width",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "width",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "Theme",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "theme",maxlength:50}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Emptymsg",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "emptymsg",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Pivot At",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "pivot_at",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "Query Group",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "query_group",maxlength:50}),
...controls.displayText({ tab: "general", label: ""}),
...controls.checkBox({ tab: "general", label: "Active",default:true, name: "widget_active" }),
...controls.displayText({ tab: "general", label: "Extra Format",width:"col-sm-12"}),
...controls.simpleeditor({ tab: "general",name: "extra_format"}),
...controls.displayText({ tab: "widget_label", label: "Display Field",star:true}),
...controls.text({ tab: "widget_label",  placeHolder: "", name: "widget_label.display_field",isRequired:true,width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "widget_label", label: "Url Field",star:false}),
...controls.text({ tab: "widget_label",  placeHolder: "", name: "widget_label.url_field",width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "widget_label", label: "Url Value Field",star:false}),
...controls.text({ tab: "widget_label",  placeHolder: "", name: "widget_label.url_value_field",width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "widget_label", label: "Url Value Field 2",star:false}),
...controls.text({ tab: "widget_label",  placeHolder: "", name: "widget_label.url_value_field_2",width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "widget_label", label: "Truncate After",star:false}),
...controls.numberOnly({ tab: "widget_label",  placeHolder: "", name: "widget_label.truncate_after",maxlength:200}),
...controls.displayText({ tab: "widget_label", label: ""}),
...controls.displayText({ tab: "widget_label", label: "Width",star:false}),
...controls.text({ tab: "widget_label",  placeHolder: "", name: "widget_label.width",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "widget_label", label: "Font",star:false}),
...controls.text({ tab: "widget_label",  placeHolder: "", name: "widget_label.font",width:"col-sm-4",maxlength:300}),
...controls.displayText({ tab: "widget_label", label: "Font Size",star:false}),
...controls.text({ tab: "widget_label",  placeHolder: "", name: "widget_label.font_size",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "widget_label", label: "Clickable Condition",star:false}),
...controls.text({ tab: "widget_label",  placeHolder: "", name: "widget_label.clickable_condition",width:"col-sm-4",maxlength:500}),
...controls.checkBox({ tab: "widget_label", label: "Is Open In New",default:false, name: "widget_label.is_open_in_new" }),
...controls.displayText({ tab: "widget_value", label: "Display Field",star:true}),
...controls.text({ tab: "widget_value",  placeHolder: "", name: "widget_value.display_field",isRequired:true,width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "widget_value", label: "Display Condition",star:false}),
...controls.text({ tab: "widget_value",  placeHolder: "", name: "widget_value.display_condition",width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "widget_value", label: "Url Field",star:false}),
...controls.text({ tab: "widget_value",  placeHolder: "", name: "widget_value.url_field",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "widget_value", label: "Truncate After",star:false}),
...controls.numberOnly({ tab: "widget_value",  placeHolder: "", name: "widget_value.truncate_after",maxlength:200}),
...controls.displayText({ tab: "widget_value", label: ""}),
...controls.displayText({ tab: "widget_value", label: "Width",star:false}),
...controls.text({ tab: "widget_value",  placeHolder: "", name: "widget_value.width",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "widget_value", label: "Font",star:false}),
...controls.text({ tab: "widget_value",  placeHolder: "", name: "widget_value.font",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "widget_value", label: "Font Size",star:false}),
...controls.text({ tab: "widget_value",  placeHolder: "", name: "widget_value.font_size",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "widget_value", label: "Background Color",star:false}),
...controls.text({ tab: "widget_value",  placeHolder: "", name: "widget_value.background_color",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "widget_value", label: "Background Color Condition",star:false}),
...controls.text({ tab: "widget_value",  placeHolder: "", name: "widget_value.background_color_condition",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "widget_value", label: "Clickable Condition",star:false}),
...controls.text({ tab: "widget_value",  placeHolder: "", name: "widget_value.clickable_condition",width:"col-sm-4",maxlength:500}),
...controls.checkBox({ tab: "widget_value", label: "Is Open In New",default:false, name: "widget_value.is_open_in_new" }),
...controls.displayText({ tab: "widget_chart", label: "Label Field",star:false}),
...controls.text({ tab: "widget_chart",  placeHolder: "", name: "widget_chart.label_field",width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "widget_chart", label: "Axes Labels",star:false}),
...controls.text({ tab: "widget_chart",  placeHolder: "", name: "widget_chart.axes_labels",width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "widget_chart", label: "Legend",star:false}),
...controls.text({ tab: "widget_chart",  placeHolder: "", name: "widget_chart.legend",width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "widget_chart", label: "Column Defs",star:false}),
...controls.text({ tab: "widget_chart",  placeHolder: "", name: "widget_chart.column_defs",width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "widget_chart", label: "Index By",star:false}),
...controls.text({ tab: "widget_chart",  placeHolder: "", name: "widget_chart.index_by",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "widget_chart", label: "Aria Label",star:false}),
...controls.text({ tab: "widget_chart",  placeHolder: "", name: "widget_chart.aria_label",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "widget_progressbar", label: "Label Field",star:false}),
...controls.text({ tab: "widget_progressbar",  placeHolder: "", name: "widget_progressbar.label_field",width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "widget_progressbar", label: "Pct Labels",star:false}),
...controls.text({ tab: "widget_progressbar",  placeHolder: "", name: "widget_progressbar.pct_labels",width:"col-sm-4",maxlength:500}),
...controls.displayText({ tab: "widget_progressbar", label: "Subtotal Definitions",star:false}),
...controls.text({ tab: "widget_progressbar",  placeHolder: "", name: "widget_progressbar.subtotal_definitions",width:"col-sm-4",maxlength:500}),
...controls.checkBox({ tab: "widget_progressbar", label: "Is Pct",default:false, name: "widget_progressbar.is_pct" }),
...controls.displayText({ tab: "widget_menus", label: "Form",star:true}),
...controls.oc({ tab: "widget_menus", c: "Form", placeHolder: "Form Code", name: "form_code",fastpath: "forms",hidden:false}),
...controls.showData({ tab: "widget_menus", displaytype: "capital", data: "form_display"}),
...controls.displayText({ tab: "widget_menus", label: "Form Label",star:false}),
...controls.text({ tab: "widget_menus",  placeHolder: "", name: "form_label",width:"col-sm-4",maxlength:100}),

...controls.displayText({ tab:"widget_menus" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"widget_menus" ,width:"col-sm-4", label: "" }),
...controls.button({
tab:"widget_menus",
 label: "ADD",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "appendToHTMLTable",
  tableNameField: "widget_menus",
  requiredField: ["form_code","form_display","form_uid","form_label",],
required:["form_code","form_display","form_uid",],
}, width: "col-sm-2"
}),
...controls.button({
tab:"widget_menus",
 label: "CLEAR",
 style: { padding: 0 },
Bcolor: "warning",
 onclick: {
  action: "clearForm",
  tableNameField: "widget_menus",
  requiredField: ["form_code","form_display","form_uid","form_label",]
}, width: "col-sm-2"
}),
{
  tab:"widget_menus",
inputType: "table",
  tableTitle: "",
  deletable: true,
  editable: true,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
    { label: "Form Code", field: "form_code"},
    { label: "Form ", field: "form_display"},
    { label: "Form Label", field: "form_label"},
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "widget_menus"
},
]
,history:{
perPage: 10,
reportHeader: "Widgets",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Widget Code",accessor: "widget_code",},
{Header: "Widget",accessor: "widget_display",},
{Header: "Widget Type",accessor: "Widget-widget_type-widget_type_display",},
{Header: "Form Code",accessor: "Widget-form-form_code",},
]}};
export default widgets;